import { render, staticRenderFns } from "./ReOpenModal.vue?vue&type=template&id=27bc97f8&"
import script from "./ReOpenModal.vue?vue&type=script&lang=js&"
export * from "./ReOpenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports